import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import Icon from "@components/icon";

import Counter from "../../../Counter";

import styles from "./BottomMenuButton.scss";

const cx = classnames.bind(styles);

const BottomMenuButton = ({
  label,
  smallLabel,
  dropdown,
  iconName,
  onClick,
  href,
  active,
  avatar,
  counter,
}) => {
  const content = (
    <>
      <div className={cx("avatar-wrapper")}>
        {avatar || (
          <Icon
            name={iconName}
            size="m"
            color="var(--glz-color-neutral-tone-5)"
          />
        )}
        {!!counter && (
          <Counter className={cx("counter")} active maxValue={9} size="medium">
            {counter}
          </Counter>
        )}
      </div>
      <span className={cx("text-label", { mobile: !!smallLabel })}>
        {label}
      </span>
      {!!smallLabel && (
        <span className={cx("text-label", "small-mobile")}>{smallLabel}</span>
      )}
    </>
  );

  return href ? (
    <a
      className={cx("bottom-menu-link", { active })}
      href={href}
      onClick={onClick}
    >
      {content}
    </a>
  ) : (
    <div className={cx("bottom-menu-button-wrapper")}>
      <button
        className={cx("bottom-menu-button", { active })}
        onClick={onClick}
      >
        {content}
      </button>
      {!!active && !!dropdown && dropdown}
    </div>
  );
};

BottomMenuButton.propTypes = {
  iconName: PropTypes.string,
  label: PropTypes.string,
  smallLabel: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
  active: PropTypes.bool,
  dropdown: PropTypes.node,
  avatar: PropTypes.node,
  counter: PropTypes.number,
};

export default BottomMenuButton;
